import { render, staticRenderFns } from "./TipoCardapio.vue?vue&type=template&id=228124e6&"
import script from "./TipoCardapio.vue?vue&type=script&lang=js&"
export * from "./TipoCardapio.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports